module.exports = __webpack_public_path__ + "static/img/taiHeImg4.77e5969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg4.jpg
// module id = +tBR
// module chunks = 2